export { default } from './dnd-styles';
